<template>
  <div class="user-info-bonus-scan-wrapper">
    <display-navigation title="赠票领取" path="user_info" />
  </div>
</template>

<script>
import wx from 'jweixin-module';
import { getWeixinConfigParams, getBonusId } from '../../api/api-ticket';
import DisplayNavigation from '../../components/DisplayNavigation';

export default {
  components: {
    DisplayNavigation,
  },
  beforeRouteEnter(to, from, next) {
    next();
    if (from.name) {
      window.location.reload();
    }
  },
  created() {
    this.handleInit();
  },
  methods: {
    async handleInit() {
      const config = await getWeixinConfigParams();
      if (config) {
        wx.config(config);
        wx.ready(() => {
          wx.scanQRCode({
            needResult: 1,
            success: this.handleScanSuccess,
            cancel: this.back,
          });
        });
      } else {
        this.back();
      }
    },
    async handleScanSuccess({ resultStr }) {
      try {
        const { free_id: freeId, ticket_id: id } = await getBonusId(resultStr);
        this.$router.push({
          name: 'bonus_detail',
          query: { id, freeId },
        });
      } catch {}
    },
    back() {
      this.$router.push({ name: 'user_info_index' });
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-bonus-scan-wrapper {
  margin-bottom: 50px;
  .btn-wrapper {
    margin: 100px 50px;
  }
}
</style>
